import React, { useEffect } from "react";
import { useDrop } from "react-dnd";

type Props = {
  visible: boolean;
  direction: "top" | "bottom";
};

const SCROLL_VELOCITY_PX = 80;
let interval: NodeJS.Timeout;

export const BrowserScrollZone: React.FC<Props> = ({ direction, visible }) => {
  const [{ isOver }, drop] = useDrop({
    accept: "track",
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: true,
    }),
  });

  useEffect(() => {
    if (isOver) {
      interval = setInterval(() => {
        window.scrollTo({
          top:
            direction === "top"
              ? window.scrollY - SCROLL_VELOCITY_PX
              : window.scrollY + SCROLL_VELOCITY_PX,
        });
      }, 100);
    } else if (interval != null) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isOver]);

  if (!visible) {
    return null;
  }

  return (
    <div
      ref={drop}
      style={{
        width: "100%",
        borderBottom: "100px solid rgba(0, 0, 0, 0)",
        position: "fixed",
        ...{
          top: direction === "top" ? 0 : undefined,
          bottom: direction === "bottom" ? 0 : undefined,
        },
        height: 10,
        zIndex: 1,
      }}
    ></div>
  );
};
